export default "__VITE_PUBLIC_ASSET__837bcba2__"